import { END_POINT } from "@constants/api.constants";
import { checkForExpiredToken } from "@screens/system/settings/setting-list/setting.list.service";
import { store } from "@src/store";

const { PROMO_CODE_EDIT, PROMO_CODE_DELETE } = END_POINT;

export const editPromoCode = async (id, payload) => {
  return await fetch(`${PROMO_CODE_EDIT}${id}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status) return { status: true, data: data.data };
      else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};

export const getPromoCodeById = async (id) => {
  return await fetch(`${PROMO_CODE_DELETE}?promo-code_id=${id}`, {
    method: "GET",
    headers: {
      "content-type": "application/json",
      token: store.getState().app.token,
    },
  })
    .then((res) => res.json())
    .then((data) => {
      if (data.status && data.data.list && data.data.list.length > 0) {
        return { status: true, data: data.data.list[0] };
      } else {
        checkForExpiredToken(data.message);
        return { status: false, message: data.message || "Promo Code not found" };
      }
    })
    .catch(function (error) {
      return {
        status: false,
        message: "Something went wrong, please try again later.",
        error,
      };
    });
};